import React, { useState } from 'react';
import { createNumberRainRound, GameShell, usePausableTimeout } from '../shared';
import { formatGameCopy } from './gameCopy';

function NumberRainGame({ copy = {}, initialLevel = 1, isPaused = false, ...props }) {
    const startLevel = Math.max(1, Math.min(21, Math.round(Number(initialLevel) || 1)));
    const { schedule: scheduleTimer } = usePausableTimeout(isPaused);
    const [round, setRound] = useState(1);
    const [level, setLevel] = useState(startLevel);
    const [trial, setTrial] = useState(() => createNumberRainRound(startLevel));
    const [choice, setChoice] = useState(null);
    const [score, setScore] = useState(0);
    const [streak, setStreak] = useState(0);
    const correctChoice = choice !== null && choice === trial.answer;

    const choose = (answer) => {
        if (isPaused || choice !== null) {
            return;
        }

        const correct = answer === trial.answer;
        const nextStreak = correct ? streak + 1 : 0;
        const nextLevel = Math.min(
            21,
            level + (correct && nextStreak % 2 === 0 ? 1 : 0)
        );
        setChoice(answer);
        setScore((current) => current + (correct ? 1 : 0));
        setStreak(nextStreak);

        scheduleTimer(() => {
            const nextRound = round + 1;
            setRound(nextRound);
            setLevel(nextLevel);
            setTrial(createNumberRainRound(nextLevel));
            setChoice(null);
        }, correct ? 650 : 900);
    };

    return (
        <GameShell
            {...props}
            copy={copy}
            disabled={isPaused}
            metrics={{ level, score, streak }}
            tone={correctChoice ? 'good' : choice !== null ? 'miss' : 'ready'}
        >
            <div className="UFOV-brain-games__rain-game">
                <div
                    aria-label={formatGameCopy(copy.equation, { equation: trial.equation })}
                    className="UFOV-brain-games__rain-equation"
                >
                    {trial.equation}
                </div>
                <div className="UFOV-brain-games__rain-options">
                    {trial.options.map((option) => {
                        const picked = choice === option;
                        const answer = choice !== null && option === trial.answer;
                        return (
                            <button
                                aria-label={formatGameCopy(copy.answerValue, { value: option })}
                                className={`UFOV-brain-games__rain-answer ${picked ? 'is-picked' : ''} ${answer ? 'is-correct' : ''}`.trim()}
                                disabled={isPaused || choice !== null}
                                key={`${trial.id}-${option}`}
                                onClick={() => choose(option)}
                                type="button"
                            >
                                {option}
                            </button>
                        );
                    })}
                </div>
            </div>
        </GameShell>
    );
}

export default NumberRainGame;
